import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./PA/Auth/Login";
import DeleteAccount from "./PA/Auth/DeleteAccount";
import SideNavBar from "./PA/sidebar";
import NavBar from "./PA/navbar";
import Dashboard from "./PA/Dashboard/Dashboard";
import UserData from "./PA/userDetails";
import UserLogInLogData from "./PA/userLoginLogDetails";
import TaskDataById from "./PA/task_view/TaskDetailsModel";
import TaskData from "./PA/taskDetails";
import CompletedTask from "./PA/completedTask";
import TaskAdd from "./PA/taskAddNew";
import TaskEdit from "./PA/taskEdit";
import Department from "./PA/department";
import Designation from "./PA/role";
import Role from "./PA/rolecopy";
import TreeStructure from "./PA/treeStructure";
import DeleteRequest from "./PA/deleteRequestpage";
import "./App.css";
import Version from "./PA/version";

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const AppContent = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation(); 

  const pathToTitle = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/user-details": "User Details",
    "/task-details": "Task Details",
    "/completed-task": "Completed Tasks",
    "/task-add": "Add Task",
    "/task-edit": "Edit Task",
    "/department-details": "Departments",
    "/designation-details": "Designations",
    "/delete-request": "Delete Request",
    "/login-logs": "Login Logs Details",
    "/view-tree" : "Organization Tree",
    "/app-version" : "App Version",
  };

  const OpenPage = pathToTitle[location.pathname] || "Dashboard";

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <SideNavBar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        setIsCollapsed={setIsSidebarCollapsed}
        setOpenPage={OpenPage}
      />

      <div
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
          isSidebarCollapsed ? "ml-[3.5rem]" : "ml-[13.9rem]"
        }`}
      >
        <NavBar title={OpenPage} />

        <div className="flex-1 overflow-auto bg-gray-100">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-details" element={<UserData isSidebarCollapsed={isSidebarCollapsed} />} />
            <Route path="/task-add" element={<TaskAdd />} />
            <Route path="/task-edit/:id" element={<TaskEdit />} />
            <Route path="/task-details/:taskGroupId" element={<TaskDataById />} />
            <Route path="/task-details" element={<TaskData />} />
            <Route path="/completed-task" element={<CompletedTask />} />
            <Route path="/department-details" element={<Department />} />
            <Route path="/role-details" element={<Role />} />
            <Route path="/view-tree" element={<TreeStructure />} />
            <Route path="/designation-details" element={<Designation />} />
            <Route path="/login-logs" element={<UserLogInLogData />} />
            <Route path="/delete-request" element={<DeleteRequest />} />
            <Route path="/app-version" element={<Version />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Login Routes */}
      <Route path="/login" element={<Login />} />

      {/* After LogIn Routes */}
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppContent />
          </RequireAuth>
        }
      />
    </Routes>

    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  </BrowserRouter>
);

export default App;
